import React, { ReactElement } from 'react'
import { Theme, withStyles, Container, Typography,
     Box, List, ListItem, ListItemIcon, ListItemText, Grid } from '@material-ui/core'
import SquareIcon from '@material-ui/icons/SquareFootRounded'

interface Props {
    classes:{[key:string]:any}
}
const styles=(theme:Theme)=>({
    aboutContainer:{
        padding: theme.spacing(5),
        borderRadius: 14
    },
    aboutSection:{
        '&>dl':{
            '& >dt':{
                color:theme.palette.primary.main,
                fontSize:20
            },
            '& >dd':{
                lineHeight:2
            }
        }
    }
})
const  AboutUs=withStyles(styles)(({classes}: Props)=>{
    return (
        <Container className={classes.aboutContainer}>
          <Typography align="center" variant="h4" color="primary">ماذا عن فاست دو</Typography>
          <Grid className={classes.aboutSection}>
              <dl>
                  <dt>ما هو فاست دو ؟</dt>
                  <dd>هو موقع يعمل على  القضايا والمشاكل التى تنشأ خلال التعامل بين الصيادلة مع بعضهم لبعض 
                      , وبين الصيادلة والمخازن ,يحاول فاست دو ايجاد حل لكل او لاغلب هذه المشاكل ,
                      بحيث ان يجدا عملاء هذا الموقع طرق الية حل مشكلاتهم بدلا من الطرق اليدوية الروتينية الصعبة 
                      والتى فى الغالب تكون مهدرة للوقت والمال
                  </dd>
                  <dt>ما هو تاريخ فاست دو ؟</dt>
                  <dd>فاست دو لم يمر على انطلاقة شهور قليلة حتى الان ,ولكن من المتوقع ان يكون الموقع زو اهمية
                      كبيرة لدى كل الفئات المستهدفة من اصحاب الصيدليات والمخازن والصيادلة ,نظرا للقضية الصعبة التى يغمل فاست دو على حلها
                  </dd>
                  <dt>ما هى المشكلات التى يقوم فاست دو  باستهدافها ومحاولة ايجاد حلول لها ؟</dt>
                  <dd>
                      <span>بالطبع فاست دو يستهدف عدة مشاكل  ومنها</span>
                      <ul>
                          <li>مشكلة استبدال الرواكد بين الصيادلة, وهى من المشكلات الهامة والاساسية التى يركز فاست دو, حيث 
                              انه يكون من الصعب التواصل بين الصيادلة من خلال الجروبات مثل جروبات السوشيال ميديا ,والتى تكون غير منظمة 
                              بالنسبة لهم, خصوصا عندما يكون عدد المتواصلين اكثر من اثنين, حيث يقوم كل صيدلى بكتابة رواكدة عن طريق 
                               رسالة عادية داخل البوكس المخصص للجروب ,بعد يومين او اكثر قد يناسى البعض تلك الرسالة ,وذلك لصعوبة 
                                البعض على قراءة كل تلك الرسائل السابقة ,فالبطبع هذا مثال واحد ,يدل على ان تلك العملية غير منظمة 
                                 وتحتاج الى تنظيم دقيق, بحث يمكن للصيادلة متابعة الرواكد بسهولة ويسر.
                          </li>
                          <li>ايضا مشكلة ان يقوم الصيدلى بعرض رواكدة ,ويقوم بنشرها الى كل الصيادلة هلى مشكلة الصعبة 
                              ,فاست دو يمكن الصيادلة من اضافة رواكدهم وعمل مخزن افتراضى من خلال فاست دو, 
                              وعندما يقوم اى مستهلك بالبحث عن هذه الرواكد تظهر له مباشرة فى نتائج البحث
                          </li>
                          <li>
                             مشكلة الصيادلة المورديين رواكدهم فى متابعتهم للمستهلكين فى تحديد السعر والوقت والمكان 
                             لاستهلاك الراكد , فاست دو يسهل هذه العملية بين الطرفين 
                          </li>
                          <li>
                              مشكلة الصيادلة فى التعامل اليدوى والتواصل مع المخازن والعكس ايضا, 
                              فاست دو يمكن المخازن من عرض مخازنهم والعروض والتخفيضات الخاصة بهم على الموقع ,
                              وذلك يمكن الصيادلة من متابعتهم والتعامل معهم بسهولة
                          </li>
                      </ul>
                  </dd>
                  <dt>ما هو المتوقع من فاست دو فى المستقبل ؟</dt>
                  <dd>مستقبليا سيبذل فاست دو قصارى الجهد والعطاء لتطوير  خدماته لكى  تناسب العملاء 
                      بشكل اكثر ارتياحية وسهولة ,وتوفر على عملائها كل الوقت والمال المهدر ,
                      وستجتهد ايضا بان تضيف خدمات جديدة لحلول مشكلات اخرى تعيق العملاء وتقف امامهم
                  </dd>
              </dl>
          </Grid>
        </Container>)
})

export default AboutUs
